module.exports = __webpack_public_path__ + "media/images/sp/plans/icon2-b5d42ac8d8a95e0df73dfc98e098e232.svg";